// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88bc30dd","455":"d8f9b09a","977":"1317941c"}[chunkId] + ".chunk.js";
};